import { z } from 'zod';
const LoyaltyCommandContextSchema = z.object({
    organizationId: z.string().uuid(),
    branchId: z.string().uuid(),
    customerId: z.string().uuid(),
    points: z.number().int().min(1).max(1_000_000),
    idempotencyKey: z.string().trim().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{7,127}$/),
    note: z.string().trim().min(1).max(500).optional(),
}).strict();
export const LoyaltyEarnSchema = LoyaltyCommandContextSchema;
export const LoyaltyRedeemSchema = LoyaltyCommandContextSchema;
export const LoyaltyTierListSchema = z.object({ organizationId: z.string().uuid() }).strict();
export const LoyaltyTierCreateSchema = z.object({
    organizationId: z.string().uuid(),
    name: z.string().trim().min(1).max(80),
    // This is an administrator-defined eligibility threshold. CT-04 never
    // promotes an account automatically; assignment is an explicit command.
    minimumPoints: z.number().int().min(0),
}).strict();
export const LoyaltyTierAssignSchema = z.object({
    tierId: z.string().uuid(),
}).strict();
export const LoyaltyTierSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(80),
    minimumPoints: z.number().int().min(0),
    createdAt: z.string(),
}).strict();
export const LoyaltyEligibleCustomerSchema = z.object({
    id: z.string().uuid(),
    displayName: z.string().min(1).max(160),
    hasAccount: z.boolean(),
}).strict();
export const LoyaltyAccountSummarySchema = z.object({
    // Eligibility precedes account creation. A null identifier is the governed
    // zero state and never represents a fabricated account.
    accountId: z.string().uuid().nullable(),
    customerId: z.string().uuid(),
    tierId: z.string().uuid().nullable(),
    tierName: z.string().nullable(),
    // PostgreSQL bigint is intentionally transported as a decimal string so a
    // future high-volume account cannot lose precision in browser JavaScript.
    balancePoints: z.string().regex(/^-?\d+$/),
}).strict();
export const LoyaltyLedgerHistoryItemSchema = z.object({
    ledgerEntryId: z.string().uuid(),
    entryKind: z.enum(['EARN', 'REDEEM']),
    pointsDelta: z.number().int(),
    balanceAfter: z.string().regex(/^-?\d+$/),
    branchId: z.string().uuid(),
    occurredAt: z.string(),
    note: z.string().nullable(),
}).strict();
export const LoyaltyAccountResponseSchema = z.object({ success: z.literal(true), data: LoyaltyAccountSummarySchema }).strict();
export const LoyaltyEligibleCustomersResponseSchema = z.object({
    success: z.literal(true),
    data: z.array(LoyaltyEligibleCustomerSchema).max(100),
}).strict();
export const LoyaltyHistoryResponseSchema = z.object({ success: z.literal(true), data: z.array(LoyaltyLedgerHistoryItemSchema).max(100) }).strict();
export const LoyaltyCommandResponseSchema = z.object({ success: z.literal(true), data: z.object({ id: z.string().uuid() }).strict() }).strict();
export const LoyaltyTiersResponseSchema = z.object({ success: z.literal(true), data: z.array(LoyaltyTierSchema).max(100) }).strict();
export const LoyaltyTierResponseSchema = z.object({ success: z.literal(true), data: LoyaltyTierSchema }).strict();
//# sourceMappingURL=loyalty.js.map